import MovieCard from "../components/MovieCard";
import MovieDB from "../utils/axios-instance";
import { useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { TiChevronLeft, TiChevronRight } from "react-icons/ti";

const Homepage = () => {
    const [movies, setMovies] = useState([]);
    const [query, setQuery] = useState("");
    const [searchParams] = useSearchParams();
    const page = Number(searchParams.get("page"));

    const getMovies = () => {
        MovieDB.get("/movie/popular", {
            params: { page },
        }).then(({ data }) => setMovies(data.results));
    };

    const updateQuery = ({ target }) => setQuery(target.value);

    useEffect(() => {
        window.scroll(0, 0);
        getMovies();
    }, [page]);

    return (
        <div className="bg-zinc-800 h-full relative">
            <div className="bg-image">
                <div className="h-64 bg-black/20 flex justify-center items-center">
                    <Link to="/?page=1">
                        <img
                            src="/icons/tmdb.svg"
                            alt="icon"
                            width="200px"
                            height="200px"
                        />
                    </Link>
                </div>
            </div>
            <div className="flex flex-col items-center">
                <div className="flex justify-around items-center my-12 w-full">
                    <input
                        className="w-11/12 md:w-2/3 p-5 shadow-lg rounded-lg bg-zinc-900 font-bold outline-none"
                        type="text"
                        placeholder="Search for movies...   🔍"
                        value={query}
                        onChange={updateQuery}
                    />
                </div>
                <div className="grid grid-cols-movie-collection w-5/6 gap-6 place-items-center last:mb-12">
                    {movies
                        .filter((item) =>
                            item.title
                                .toLowerCase()
                                .includes(query.toLowerCase())
                        )
                        .map((item) => (
                            <MovieCard {...item} key={item.id} />
                        ))}
                </div>
                <div className="flex justify-between items-center w-full my-8 mx-4 md:w-2/3">
                    <Link
                        to={`?page=${~~(page > 0) && page - 1}`}
                        className="flex"
                    >
                        <TiChevronLeft size={24} />
                        Previous Page
                    </Link>
                    <Link
                        to={`?page=${~~(page < 1000) && page + 1}`}
                        className="flex"
                    >
                        Next Page
                        <TiChevronRight size={24} />
                    </Link>
                </div>
            </div>
        </div>
    );
};
export default Homepage;
